module.exports = __webpack_public_path__ + "img/envelope-icon.7e111cf2.svg";